import React from 'react';
import { TableRow, TableCell, IconButton, Box, Menu, MenuItem } from '@mui/material';
import { CustomerWithId } from '../../../models/customer.model';
import styles from '../CustomerProfiles.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';

type SupplierRowProps = {
  customer: CustomerWithId;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const CustomerRow: React.FC<SupplierRowProps> = ({
  customer,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <TableRow className={styles.table_row} key={customer.id}>
      <TableCell
        id={`customerRowNameCell_${customer.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.customer_name}
      </TableCell>
      <TableCell
        id={`customerRowEmailCell_${customer.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.email_address || '-'}
      </TableCell>
      <TableCell
        id={`customerRowWebsiteCell_${customer.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.website || '-'}
      </TableCell>
      <TableCell
        id={`customerRowPostalAddressCell_${customer.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.CUSTOMER_PROFILES}/${customer.id}`)}
      >
        {customer.postal_address || '-'}
      </TableCell>
      <TableCell className={styles.table_cell} align='right'>
        <Box
          className={styles.actions_container}
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
        >
          <IconButton
            id={`customerRowOpenMenuIconBtn_${customer.id}`}
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
            size='small'
            sx={{ p: 0.5 }}
          >
            <MoreVertIcon
              id={`customerRowOpenMenuIconBtnMoreVertIcon_${customer.id}`}
              fontSize='small'
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem
              id={`customerRowEditMenuItem_${customer.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleEdit(customer.id);
              }}
            >
              {t('buttons.edit')}
            </MenuItem>
            <MenuItem
              id={`customerRowDocumentsMenuItem_${customer.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                navigateToDocs(customer.id);
              }}
            >
              {t('buttons.documents')}
            </MenuItem>
            <MenuItem
              id={`customerRowDeleteMenuItem_${customer.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleDelete(customer.id);
              }}
            >
              {t('buttons.delete')}
            </MenuItem>
          </Menu>
        </Box>
      </TableCell>
    </TableRow>
  );
};
